<template>
  <component :is="component" :boardData="boardData" v-if="component"/>
</template>

<script>
export default {
  name: "BoardDetailLink",
  mixins: [],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {
    detailLayout: '',
    boardData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      component: null
    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
    this.loader()
        .then(() => {
          this.component = () => this.loader()
        })
        .catch(() => {
          this.component = () => import('@/template/board/detail/BoardDetailDefaultLayout');
        })
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {
    loader() {
      if (!this.detailLayout) {
        return null;
      }
      return () => import(`@/template/board/detail/${this.detailLayout}`);
    }
  },
  methods: {},
  watch: {},
}
</script>

<style scoped>

</style>